import visaIcon from "../../../icons/visa.png";
import mastercardIcon from "../../../icons/mastercard.png";
import mirIcon from "../../../icons/mir.svg";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {GetObjectCards} from "../../../api/objects/objects";
import {GetServices, NotEnoughInformationError, Pay, TariffLogicError} from "../../../api/objects/payment";
import Object from "../index";
import AutoPayment from "../../autopayment";
import pinSelected from "../../../icons/pin-selected.svg";
import pin from "../../../icons/pin.svg";
import Passengers from "../../passengers";
import Offer from "../../offer";

const Price = ({object, cards, showCards, price, disabled, pay}) => <div style={{display: "flex", gap: 8}}>
    {!disabled && object && cards.length > 0 && <div onClick={showCards} style={{
        background: "#1414140F",
        paddingTop: 8,
        borderRadius: 10,
        minWidth: 80,
        fontSize: 13
    }}>
        {cards[0].pan[0] === "4" && <img alt={"Visa"} style={{height: 12}} src={visaIcon}/>}
        {cards[0].pan[0] === "5" &&
            <img alt={"MasterCard"} style={{height: 12}} src={mastercardIcon}/>}
        {cards[0].pan[0] === "2" && <img alt={"МИР"} style={{height: 12}} src={mirIcon}/>}
        <div style={{color: "#898989"}}>····&nbsp;{cards[0].pan.slice(-4)}</div>
    </div>}
    <div style={{width: "100%"}}>
        <button className={"payment-button"} disabled={disabled} onClick={e => pay()}>
            <span>{cards.length > 0 ? "Оплатить" : "К Оплате"}</span>{price !== null ?
            <span> · {price / 100} ₽</span> : null}
        </button>
    </div>
</div>

export default({verified, object, loading, setLoading}) => {
    const navigate = useNavigate()

    useEffect(() => {
        getCards()
        fetchServices()
    }, [])

    const [service, setService] = useState(null)
    const [services, setServices] = useState([])
    const [price, setPrice] = useState(null)
    const [count, setCount] = useState(1)
    const [cards, setCards] = useState(null)
    const [cardsLoading, setCardsLoading] = useState(false)
    const [savePayment, setSavePayment] = useState(false)


    useEffect(()=> {
        if (service) {
            if (service.price !== -1) {
                setPrice(service.price)
            } else {
                setPrice(service.min_price)
            }
            setCount(service.min_count);
        }
    }, [service])

    const getCards = () => {
        setCardsLoading(true)
        GetObjectCards(object?.id)
            .then(setCards).catch(() => {
        }).finally(() => {
            setCardsLoading(false)
        })
    }

    const fetchServices = () => {
        setLoading(true)
        GetServices(object.id).then(data => {
            setServices(data.services)
        }).catch(error => {
            if (error instanceof NotEnoughInformationError) {
                setPrice(null)
            }
            if (error instanceof TariffLogicError) {
                if (count > 1) {
                    setCount(count - 1)
                }
            }
        }).finally(() => {
            setLoading(false)
        })
    }


    const pay = () => {
        setLoading(true)
        Pay(object.id, null, [{service_id: service.id, price: price, count: count}], cards?.length > 0 || savePayment)
            .then(data => {
                window.location.href = data.url;
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    return <>
        <div style={{
            fontWeight: 500,
            fontSize: 13,
            paddingLeft: 16,
            lineHeight: "16px",
            letterSpacing: "0.018em",
            color: "#898989"
        }}>
        </div>
        <div className={"objects"} style={{paddingTop: 0, paddingBottom: 4, marginTop: 16, marginBottom: 16}}>
            <Object object={object}/>
        </div>
        <div className={"objects"}>
            {(services || []).map((s, i) => <div key={i} className={"object"} onClick={e => setService(s)}>
                <div className={"object-info"}>
                    <div>
                        <div className={"vehicle-route"} style={{paddingBottom: 8}}>
                            <div className={"vehicle-route-number"}>{s.name}</div>
                        </div>
                        <div className={"vehicle-station"}>
                            {s.price !== -1 ? <div
                                    className={"vehicle-station-text"}>{s.price / 100} рублей
                                </div> :
                                <input style={{width: "90%", border:0}} className={"no-arrows"} autoFocus={service && s.id === service.id} type={"number"} step={1} min={s.min_price/100} onChange={e=>setPrice(e.target.value * 100)} max={s.max_price/100} defaultValue={s.min_price/100} value={price / 100}/>
                            }
                        </div>
                    </div>
                    <div className={"object-selection"}>
                        <div className={"object-pin"}>
                            {service && s.id === service.id ?
                                <img style={{display: "block", height: 24, width: 24}} src={pinSelected}/> :
                                <img style={{display: "block", height: 24, width: 24}} src={pin}/>}
                        </div>
                    </div>
                </div>
            </div>)}
        </div>

        <div className={"payment"}>
            {service && service.min_count !== service.max_count && <Passengers count={count}  setCount={setCount} title={"Количество"}/>}
            <Price
                object={object}
                showCards={() => navigate("/objects/cards")}
                price={price}
                cards={cards || []}
                pay={pay}
                disabled={service == null || loading || cardsLoading}/>
            <Offer/>
        </div>
    </>
}